export const COLUMN_NAME = {
  NO: "No.",
  DOC_NO: "Doc No",
  REPORT_NAME: "Report Name",
  NO_OF_ZIP_FILE: "No of Zip File",
  REQUEST_DATE: "Request Date",
  REPORT_STATUS: "Report Status",
  GENERATED_BY: "Generated BY",
};
